import BaseGenericRequest from "../BaseGenericRequest";
import TaskResponse from "../TaskResponse";
import {METHOD} from "@cuatroochenta/co-generic-request";
import Urls from "../Urls";
import {TaskCriteriaRequest} from "../TaskCriteriaRequest";
import WorkdayType from "../../model/WorkdayType";

type WorkdayTypeCriteriaProps = TaskCriteriaRequest<{}>

export default class TaskWorkdayTypeList extends BaseGenericRequest<WorkdayTypeCriteriaProps, TaskResponse<WorkdayType[]>> {

    private readonly data: WorkdayTypeCriteriaProps;

    public constructor(criteria: WorkdayTypeCriteriaProps = {}) {
        super(METHOD.POST, Urls.URL_WORKDAY_TYPE_LIST);
        this.data = criteria;
    }

    protected getRequest(): WorkdayTypeCriteriaProps {
        return this.data;
    }

}
